module.exports = __webpack_public_path__ + "static/media/26.ec270923.png";